import { apiClient } from "@/lib/auth";

const num = (v) => (v === "" || v == null ? null : Number(v));
const fmt = (n) => Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

// Where each built-in action really saves, and how its recent entries are listed / undone.
const billingRecent = (type) => ({
  list: async () => (await apiClient.get("/admin/billing/entries?limit=40")).data.entries.filter((e) => e.type === type).slice(0, 5)
    .map((e) => ({ id: e.id, at: e.occurred_at || e.created_at, text: `${fmt(type === "usage" ? e.actual_credits : e.display_credits)} credits${e.project_name ? ` · ${e.project_name}` : ""}${e.note ? ` · ${e.note}` : ""}` })),
  remove: (id) => apiClient.delete(`/admin/billing/entries/${id}`),
});

export const BUILTIN_ACTIONS = {
  credit_usage: {
    submit: (v) => apiClient.post("/admin/billing/usage", { actual_credits: num(v.actual_credits), note: v.note || "", project_id: v.project_id || null }),
    summary: (v) => `Logged ${fmt(v.actual_credits)} credits of usage`,
    validate: (v) => (num(v.actual_credits) > 0 ? null : "Credits must be greater than zero"),
    recent: billingRecent("usage"), affectsBalance: true,
  },
  credit_topup: {
    submit: (v) => apiClient.post("/admin/billing/topup", { credits: num(v.credits), cost_usd: num(v.cost_usd), note: v.note || "" }),
    summary: (v) => `Purchased ${fmt(v.credits)} credits${v.cost_usd ? ` for $${fmt(v.cost_usd)}` : ""}`,
    validate: (v) => (num(v.credits) > 0 ? null : "Credits must be greater than zero"),
    recent: billingRecent("topup"), affectsBalance: true,
  },
  add_project: {
    submit: (v) => apiClient.post("/admin/billing/projects", { name: v.name, monthly_fee: num(v.monthly_fee) || 0 }),
    summary: (v) => `Added project ${v.name}`,
  },
  add_contact: {
    submit: (v) => apiClient.post("/crm/contacts", { ...v, source: "os" }),
    summary: (v) => `Added contact ${v.full_name}`,
  },
  send_sms: {
    submit: (v) => apiClient.post("/admin/sms/test", v),
    summary: (v) => `Sent SMS to ${v.recipient_name || v.phone}`,
  },
  pilot_request: {
    submit: (v) => apiClient.post("/demos/exchange-alliance/pilot-request", v),
    summary: (v) => `Pilot request · ${v.full_name} (${v.organization})`,
  },
};
